import View from '../View';
import {withSystem} from '@packages/systems/wfdl';
import {qualify, pluginName, typeName} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Empty State',
  showEmpty: true,
  uiStateOnSelected: 'empty',
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: ['SearchResultWrapper'],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: View,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
